/**
 * Costruisce il messaggio di feedback mostrato dopo "Invia LDV" (pickup mail).
 *
 * ⚠️ Il testo DIPENDE dal backend mail, non è cosmetica: su ``thunderbird`` si
 * apre una bozza e l'invio lo fa Davide; su ``smtp`` (= om.bscom.it, la
 * versione principale) la mail e' GIA' PARTITA quando questo messaggio compare.
 * Dire «Clicca Invia in Thunderbird» su smtp mandava Davide a completare un
 * invio concluso — una bugia peggiore del silenzio (regola: ogni azione dà
 * feedback chiaro e VERO in italiano).
 *
 * Caso SDA >15 colli (bug 2026-06-25 / v1.2.12, opzione C): il pickup mail
 * auto-switcha a Poste Delivery Business — un click = consenso (vedi
 * ``OrdersService.send_pickup_mail``). L'avviso del cambio corriere va davanti
 * su entrambi i backend: è la cosa che Davide deve vedere per prima.
 */
import type { MailBackend } from "@/features/mail/api";
import type { SendPickupMailResult } from "./api";

/** Etichette user-facing dei codici corriere usati nello switch. */
const CARRIER_LABELS: Record<string, string> = {
  POSTE_DELIVERY: "Poste Delivery Business",
};

export function formatPickupMailMessage(
  result: SendPickupMailResult,
  backend: MailBackend = "thunderbird",
): string {
  const base =
    backend === "smtp"
      ? `Mail di ritiro inviata per ${result.reference} → ${result.recipient} ` +
        `(LDV: ${result.attachment_name}).`
      : `Thunderbird aperto per ${result.reference} → ${result.recipient} ` +
        `(LDV: ${result.attachment_name}). Clicca "Invia" in Thunderbird per spedire.`;

  if (!result.carrier_switched_to) return base;

  const carrierLabel = CARRIER_LABELS[result.carrier_switched_to] ?? result.carrier_switched_to;
  const colli = typeof result.packages_count === "number" ? `${result.packages_count} colli, ` : "";

  return (
    `Attenzione — Corriere cambiato: SDA → ${carrierLabel} ` +
    `(${colli}oltre il limite SDA di 15). ` +
    base
  );
}
